import { Link } from 'react-router-dom';
import { categories } from '@/mocks/asmr';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索音频分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大场景分类，满足您不同时刻的声音需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl mb-5 transition-all duration-300 group-hover:scale-110 ${
                cat.color === 'primary'
                  ? 'bg-primary-100 text-primary-600'
                  : cat.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                浏览音频 <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}